import React from 'react';
import { inviteChipClass, sideChipClass, fmtDate } from '../../utils/helpers';

// One function invitation card with RSVP controls. Shared by desktop & mobile
// (the invite page itself is platform-split; this leaf is identical on both).
function mapsHref(gps) {
  if (!gps) return null;
  const s = String(gps).trim();
  if (/^https?:\/\//i.test(s)) return s; // already a maps URL
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s)}`;
}

// Mobile (APK / phone) invitation card: full-width RSVP buttons.
export default function InviteCardMobile({ vm, row }) {
  const { savingId, rsvp: onRsvp, setConfirmedCount: onCount } = vm;
  const answer = row.RSVPStatus && row.RSVPStatus !== 'Pending' ? row.RSVPStatus : null;
  const saving = savingId === row.GuestId;
  const maps = mapsHref(row.GpsLocation);
  const venue = [row.Venue, row.VenueAddress, row.City].filter(Boolean).join(', ');

  return (
    <div className="card card-pad" style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <strong style={{ fontSize: 16 }}>{row.FunctionName || 'Function'}</strong>
        <div style={{ flex: 1 }} />
        {row.Side && row.Side !== 'Common' && <span className={sideChipClass(row.Side)}>{row.Side}</span>}
      </div>

      <div style={{ marginTop: 6, fontSize: 14, display: 'grid', gap: 4 }}>
        <div>📅 {fmtDate(row.FunctionDate)}{row.FunctionTime ? ` · 🕒 ${row.FunctionTime}` : ''}</div>
        {venue && <div>📍 {venue}</div>}
        {maps && <div><a href={maps} target="_blank" rel="noreferrer">🗺️ Open venue in Maps</a></div>}
        <div className="muted" style={{ fontSize: 13 }}>Invited: {row.ExpectedCount ?? 1} person(s)</div>
      </div>

      <div style={{ marginTop: 12, borderTop: '1px solid var(--line)', paddingTop: 10 }}>
        {answer ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span>Your response:</span>
            <span className={inviteChipClass(row.RSVPStatus === 'Yes' ? 'Confirmed' : row.RSVPStatus === 'No' ? 'Declined' : 'Invited')}>
              {row.RSVPStatus}
            </span>
            {row.RSVPStatus === 'Yes' && (
              <span className="muted" style={{ fontSize: 13 }}>· {row.ConfirmedCount || row.ExpectedCount || 1} coming</span>
            )}
            <button className="btn light sm" disabled={saving} onClick={() => onRsvp(row, null)} style={{ marginLeft: 'auto' }}>
              Change
            </button>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: 8 }}>
            <div className="muted" style={{ fontSize: 13 }}>Will you attend?</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
              <button className="btn primary" disabled={saving} onClick={() => onRsvp(row, 'Yes')}>✅ Yes</button>
              <button className="btn light" disabled={saving} onClick={() => onRsvp(row, 'Maybe')}>🤔 Maybe</button>
              <button className="btn danger" disabled={saving} onClick={() => onRsvp(row, 'No')}>❌ No</button>
            </div>
            <label className="muted" style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
              How many coming?
              <input type="number" min={1} value={row.ConfirmedCount || row.ExpectedCount || 1}
                onChange={(e) => onCount(row, e.target.value)} inputMode="numeric"
                style={{ width: 90, padding: '10px 8px', fontSize: 16, border: '1px solid var(--line)', borderRadius: 8 }} />
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
